import { useEffect, useMemo, useState } from "react";
import type { RuntimeValue } from "../api/config";
import { useCopy } from "../i18n/copy";

const toSeconds = (value: RuntimeValue) =>
  Number(value.day || 0) * 86400 +
  Number(value.hour || 0) * 3600 +
  Number(value.minute || 0) * 60 +
  Number(value.second || 0);

const partsFromSeconds = (value: number) => ({
  day: Math.floor(value / 86400),
  hour: Math.floor((value % 86400) / 3600),
  minute: Math.floor((value % 3600) / 60),
  second: value % 60,
});

export function RuntimeCounter({ value }: { value: RuntimeValue }) {
  const { tr } = useCopy();
  const initial = useMemo(() => toSeconds(value), [value]);
  const [seconds, setSeconds] = useState(initial);

  useEffect(() => setSeconds(initial), [initial]);
  useEffect(() => {
    const timer = window.setInterval(
      () => setSeconds((current) => current + 1),
      1000,
    );
    return () => window.clearInterval(timer);
  }, []);

  const parts = partsFromSeconds(seconds);
  return (
    <section className="runtime-counter">
      <div className="runtime-primary">
        <small>{tr("Tiempo de operación")}</small>
        <strong>{parts.day}</strong>
        <span>{tr("días")}</span>
      </div>
      <div className="runtime-parts">
        <span>
          <strong>{String(parts.hour).padStart(2, "0")}</strong>
          <small>{tr("Horas")}</small>
        </span>
        <span>
          <strong>{String(parts.minute).padStart(2, "0")}</strong>
          <small>{tr("Minutos")}</small>
        </span>
        <span>
          <strong>{String(parts.second).padStart(2, "0")}</strong>
          <small>{tr("Segundos")}</small>
        </span>
      </div>
    </section>
  );
}
